import React, { useEffect } from "react";
import useTracking from "./src/hooks/useTracking";
import "./src/styles/global.css";

const TrackedApp = ({ children }: { children: any }) => {
  // Get any tracking ids once per visit
  const { storeClickId } = useTracking();
  useEffect(() => {
    storeClickId();
  }, []);

  return children;
};

export const wrapRootElement = ({ element }: { element: any }) => {
  return <TrackedApp>{element}</TrackedApp>;
};
